import { authorizedRequest } from 'api'
import { StudentUpdateRequest } from 'types'
import { ErrorProp } from './'

export type UpdateResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type UpdateProps = {
  formData?: StudentUpdateRequest
}

export async function update({
  formData,
}: UpdateProps): Promise<UpdateResponseProps> {
  try {
    if (!formData?.id) {
      throw Error('User ID is required')
    }
    const endpoint = `/user/${formData?.id}`

    const response = await authorizedRequest({
      method: 'PATCH',
      endpoint,
      body: formData,
    })

    const json = (await response.json()) as UpdateResponseProps
    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
